/**
 * @param jsonValues.bars
 * @param jsonValues.highestMaxValue
 */

// ATTENTION UI DESIGNERS
// ---------------------
// This is an Echart definition of a chart. You can explore it in the PLAYGROUND.
// Echarts list of examples: https://echarts.apache.org/examples/en/index.html#chart-type-pie
// An example Echart: https://echarts.apache.org/examples/en/editor.html?c=pie-doughnut
// PLAYGROUND: https://echarts.apache.org/examples/en/editor.html
// DOCUMENTATION: https://echarts.apache.org/en/option.html
// NOTE: always verify that this file works in both Connect and the PLAYGROUND
// This entire file can be cut and pasted into the PLAYGROUND IF you change the commenting on the following 2 lines



// In the PLAYGROUND, comment out this line. In this file, keep it uncommented.
export { options };
// In the PLAYGROUND, uncomment this line and add/change values. In this file, keep it commented.
// option = options({ highestMaxValue: 23, bars: [{ result: 10, name: "aaa", value: 13}, { result: 1, name: "bbb", value: null}, { result: 0, name: "ccc", value: 0}],  });


const getHexFromToken = (token) => getComputedStyle(document.body).getPropertyValue(token)
const getTokenFromFlagInt = (flagInt) => {
  return {
    "0": "--green-600",
    "10": "--gray-500",
    "20": "--warning-500",
    "30": "--red-600",
    "40": "--blue-500",
    "50": "--blue-400"
  }[flagInt] || "--gray-500";
}
const getHexFromFlagInt = (colorValue) => getHexFromToken(getTokenFromFlagInt(colorValue));


function options(jsonValues) {
  // VARIABLES BEGIN: all variables pulled in from the jsonValues should be listed here
  const highestMaxValue = jsonValues.highestMaxValue;
  const bars = jsonValues.bars;

  // DATA
  const dataLabels = bars.map(({ name }) => name);
  const colorBarBackground = getHexFromToken("--gray-100");
  const data = bars.map((bar) => {


    return {
      itemStyle: {
        color: getHexFromFlagInt(bar.result),
      },
      value: bar.value,
    };
  });

  return {
    animationDuration: 0,
    animationDurationUpdate: 3000,
    animationEasing: "linear",
    animationEasingUpdate: "linear",
    grid: {
      containLabel: true,
      bottom: 30,
      left: 30,
      right: 30,
      top: 30,
    },
    legend: { show: false },
    series: [
      {
        backgroundStyle: {
          color: colorBarBackground,
        },
        barWidth: "10",
        data: data,
        emphasis: {
          itemStyle: {
            borderRadius: [10, 10],
          },
        },
        itemStyle: {
          borderRadius: [10, 10, 10, 10],
        },
        label: {
          position: "right",
          show: true,
          valueAnimation: true,
        },
        name: "X",
        realtimeSort: false,
        showBackground: true,
        type: "bar",
      },
    ],
    xAxis: {
      max: highestMaxValue,
      splitLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      animationDuration: 300,
      animationDurationUpdate: 300,
      axisLabel: {
        fontSize: 12,
        fontWeight: "600",
      },
      axisLine: {
        show: true,
      },
      axisTick: {
        show: false,
      },
      data: dataLabels,
      splitLine: {
        show: true,
      },
      type: "category",
    },
  };
}
